/* Foil Haul — theme.js */
(function(){
  "use strict";

  /* ---- light / dark ---- */
  var root = document.documentElement;
  var KEY = "fh-theme";
  function apply(mode){
    root.setAttribute("data-theme", mode);
    document.querySelectorAll("[data-theme-toggle]").forEach(function(b){
      b.setAttribute("aria-label", mode === "dark" ? "Switch to light mode" : "Switch to dark mode");
      var m = b.querySelector(".i-moon"), s = b.querySelector(".i-sun");
      if(m && s){ m.hidden = mode === "dark"; s.hidden = mode !== "dark"; }
    });
  }
  document.addEventListener("click", function(e){
    var t = e.target.closest("[data-theme-toggle]");
    if(!t) return;
    var next = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
    apply(next);
    try{ localStorage.setItem(KEY, next); }catch(err){}
  });
  apply(root.getAttribute("data-theme") || "light");

  /* ---- rip / ship ---- */
  document.addEventListener("click", function(e){
    var b = e.target.closest(".rs button");
    if(!b) return;
    var group = b.parentElement;
    group.querySelectorAll("button").forEach(function(x){ x.setAttribute("aria-pressed","false"); });
    b.setAttribute("aria-pressed","true");
    var form = b.closest("form");
    if(form){
      var input = form.querySelector('input[data-open-choice]');
      if(input) input.value = b.getAttribute("data-value") || b.textContent.trim();
    }
  });

  /* ---- mobile nav ---- */
  document.addEventListener("click", function(e){
    var t = e.target.closest("[data-menu-toggle]");
    if(!t) return;
    var nav = document.querySelector(".site-nav");
    if(nav) nav.classList.toggle("open");
  });

  /* ---- product gallery ---- */
  document.addEventListener("click", function(e){
    var th = e.target.closest("[data-thumb]");
    if(!th) return;
    var main = document.querySelector("[data-main-image]");
    if(main){ main.src = th.getAttribute("data-full"); main.srcset = ""; }
  });
})();
